import { type InputRule, markTypeInputRule } from "@handlewithcare/prosemirror-inputrules";
import { type MarkType } from "prosemirror-model";

// Given an "strike" markType returns an input rule that turns `"~~text~~"` in a text block
// into an <s></s> tag.
export const strikeTextRule = (markType: MarkType): InputRule => {
	return markTypeInputRule(/~~(?<content>.+)~~$/d, markType);
};
